import React from 'react';
import Media from 'react-media';

export default props => <Media query={{ minWidth: '992px' }} {...props} />;
